import { Badge } from '@/components/ui/badge';
import type { ModerationPriority, ModerationStatus } from '../types';
import { priorityDisplay, statusDisplay } from '../lib/display';

export function StatusBadge({ status }: { status: ModerationStatus }) {
  const d = statusDisplay(status);
  return <Badge variant={d.variant}>{d.label}</Badge>;
}

export function PriorityBadge({ priority }: { priority: ModerationPriority }) {
  const d = priorityDisplay(priority);
  return <Badge variant={d.variant}>{d.label}</Badge>;
}
